'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _InputConstants = require('./InputConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PLACEHOLDER = '__PLACEHOLDER__';

var UISelectInput = _react2.default.createClass({
  displayName: 'UISelectInput',

  propTypes: {
    className: _react.PropTypes.string,
    defaultValue: _react.PropTypes.string.isRequired,
    disabled: _react.PropTypes.bool,
    onChange: _react.PropTypes.func,
    options: _react.PropTypes.arrayOf(_react.PropTypes.shape({
      disabled: _react.PropTypes.bool,
      text: _react.PropTypes.string,
      value: _react.PropTypes.any.isRequired
    }).isRequired).isRequired,
    placeholder: _react.PropTypes.string,
    value: _react.PropTypes.string
  },

  contextTypes: {
    fieldSize: _react.PropTypes.oneOf(Object.keys(_InputConstants.INPUT_SIZE_OPTIONS))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      defaultValue: PLACEHOLDER
    };
  },
  renderOptgroup: function renderOptgroup(_ref) {
    var disabled = _ref.disabled,
        text = _ref.text,
        value = _ref.value,
        options = _ref.options;

    return _react2.default.createElement(
      'optgroup',
      { disabled: disabled, key: text + value, label: text || value },
      options.map(this.renderOption)
    );
  },
  renderOption: function renderOption(_ref2) {
    var disabled = _ref2.disabled,
        text = _ref2.text,
        value = _ref2.value;

    return _react2.default.createElement(
      'option',
      { disabled: disabled, key: text + value, value: value },
      text || value
    );
  },
  renderPlaceholder: function renderPlaceholder(_ref3) {
    var placeholder = _ref3.placeholder;

    if (!placeholder) {
      return null;
    }
    return _react2.default.createElement(
      'option',
      { disabled: true, key: 'placeholder', value: PLACEHOLDER },
      placeholder
    );
  },
  renderSelectOption: function renderSelectOption(option) {
    if (option.hasOwnProperty('options')) {
      return this.renderOptgroup(option);
    }
    return this.renderOption(option);
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        __defaultValue = _props.defaultValue,
        options = _props.options,
        value = _props.value,
        placeholder = _props.placeholder,
        disabled = _props.disabled,
        rest = _objectWithoutProperties(_props, ['className', 'defaultValue', 'options', 'value', 'placeholder', 'disabled']);

    return _react2.default.createElement(
      'div',
      {
        className: (0, _reactUtils.classNames)('hs-custom-select', 'private-form__control', 'private-form__select', 'form-control', 'display-inline-block', _InputConstants.INPUT_SIZE_OPTIONS[this.context.fieldSize], { 'private-form__control--disabled': disabled }, className)
      },
      _react2.default.createElement(
        'select',
        _extends({}, rest, { disabled: disabled, value: value }),
        this.renderPlaceholder({ placeholder: placeholder }),
        options.map(this.renderSelectOption)
      )
    );
  }
});

exports.default = (0, _Controllable2.default)(UISelectInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/input/UISelectInput.js
// module id = 369
// module chunks = 0